module.exports = __webpack_public_path__ + "static/17-3cb26a892b405f2e4067c4a49f9988c7.jpeg";